import React, {
  useEffect,
  useRef,
  useState,
  ComponentPropsWithoutRef,
  useCallback,
} from "react";
import useWindowDimensions from "../../hooks/useWindowDimension";
import MilestoneRenderer from "../utilities/MilestoneRenderer";

interface Props extends ComponentPropsWithoutRef<"div"> {}

const Milestones = ({ className, ...htmlProps }: Props) => {
  const { width, height } = useWindowDimensions();
  const smallOrLower: boolean = width < 768;
  const isHeightLarge: boolean = height > 1000;
  const percetageStep = isHeightLarge ? 0.82 : smallOrLower ? 0.96 : 0.91;

  const startingPercentage: number = isHeightLarge ? 12 : smallOrLower ? 4 : 6;
  const [scrollPercentage, setScrollPercentage] =
    useState<number>(startingPercentage);
  const maxPercentageReached = useRef<number>(startingPercentage);

  const [pageWasLoaded, setPageWasLoaded] = useState<boolean>(false);
  const [pageResolutionChanged, setPageResolutionChanged] =
    useState<boolean>(false);

  const handleScroll = useCallback(() => {
    const scrollTop = window.scrollY;
    const scrollHeight = document.body.scrollHeight - window.innerHeight;
    const maxScrollHeight = scrollHeight - window.innerHeight;
    const percentage =
      ((scrollTop / maxScrollHeight) * 100 + startingPercentage) *
      percetageStep;

    if (
      percentage > maxPercentageReached.current &&
      percentage > scrollPercentage &&
      percentage <= 100
    ) {
      setScrollPercentage(percentage);
      maxPercentageReached.current = percentage;
    }
  }, [scrollPercentage]);

  useEffect(() => {
    if (pageWasLoaded) {
      setPageResolutionChanged(true);
      setScrollPercentage(100);
      maxPercentageReached.current = 100;
    }
    setPageWasLoaded(true);
  }, [smallOrLower]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  return (
    <div className={className} {...htmlProps}>
      {!smallOrLower ? (
        <MilestoneRenderer
          variant="desktop"
          scrollPercentage={scrollPercentage}
          pageResolutionChanged={pageResolutionChanged}
        />
      ) : (
        <MilestoneRenderer
          variant="mobile"
          scrollPercentage={scrollPercentage}
          pageResolutionChanged={pageResolutionChanged}
        />
      )}
    </div>
  );
};

export default Milestones;
